export default __webpack_public_path__ + "static/greenshield_banner-24703ee00f6266c7b96aace696497427.png";